import QuestionController from "../question_controller"

export default class extends QuestionController {
  static targets = [
    'inputField',
    'outputValue',
    'outputDialog'
  ]
  connect() {
    this.setupRangeInput()
    this.inputFieldTarget.addEventListener("input", event => {
      this.input_changed(event)
    });
  }

  handleWidth() {
    return 24;
  }
  setupRangeInput() {
    const rangePercentage = this.calculateRangePercentage(this.inputFieldTarget.value)
    this.updateRangeBackround(this.inputFieldTarget.value, rangePercentage)
    this.updateDialog(this.inputFieldTarget.value, rangePercentage)

  }
  input_changed(event) {
    this.inputFieldTarget.setAttribute("data-length", event.target.value);
    const rangePercentage = this.calculateRangePercentage(event.target.value)
    this.updateRangeBackround(event.target.value, rangePercentage)
    this.updateDialog(event.target.value, rangePercentage)

  }

  positionDialog(percentage) {
    this.outputDialogTarget.style.left = "calc(" + percentage + "%" + " - " + ((this.outputDialogTarget.offsetWidth / 2)) + "px)"
  }

  updateDialog(value, percentage) {
    this.outputValueTarget.innerHTML = value
  }

  updateRangeBackround(value, rangePercentage) {
    const fillPercentage = this.calculateFillPercentage(value, rangePercentage)
    this.inputFieldTarget.style.background = "linear-gradient(90deg, rgb(0, 0, 0) " + fillPercentage + "%, rgba(225, 225, 225) " + fillPercentage + "%)"
  }
  calculateRangePercentage(value) {
    const sliderWidth = this.inputFieldTarget.offsetWidth
    const handleWidthPercentage = (this.handleWidth() / this.inputFieldTarget.offsetWidth) * 100.00

    if(value == this.inputFieldTarget.min)  { return (handleWidthPercentage/2) }

    const divisableBy = this.inputFieldTarget.getAttribute('data-steps')-1
    const rangePercentage = (value-this.inputFieldTarget.min) * (100 / divisableBy)
    const handleSliver = this.handleWidth() / divisableBy
    const handleSliverPercentage = ((handleSliver / sliderWidth) * (value-this.inputFieldTarget.min)) * 100.00

    return rangePercentage - handleSliverPercentage + (handleWidthPercentage/2)
  }

  calculateFillPercentage(value, percentage){
    if(value == this.inputFieldTarget.min)  { return 0 }
    return percentage
  }

  validateForm() {
    if(this.isRequired() && !this.outputValueTarget.dataset.confirmationRequest && (this.outputValueTarget.dataset.startingValue == this.inputFieldTarget.value)){
      this.outputValueTarget.dataset.confirmationRequest = true
      this.displayFlash("warning", "Confirm your answer by clicking submit.")
      return false
    }

    return true
  }

}
